import { createContext, useContext, useState } from "react";
import useFetchCommissions from "../hooks/useFetchCommissions";

export const CommissionsDataContext = createContext({})

const CommissionsDataProvider = props => {
    const { getCommissions, refetchData, getCurrentPage,setPage,loading } = useFetchCommissions()
    
    const exportedData = {       
        getCommissions,
        refetchData,
        getCurrentPage,
        setPage,
        loading
    }
    return <CommissionsDataContext.Provider value={exportedData} {...props} />
}
export const useCommissionsDataContext = () => useContext(CommissionsDataContext)

export default CommissionsDataProvider